import Schema from 'AppReact/schema';
import { unitMin, property } from 'types';

export default {
  units: Schema(unitMin, 'array', { defaultValue: [] }),
  properties: Schema(property, 'array', { defaultValue: [] }),
  selectedUnitIds: Schema('integer', 'array', { defaultValue: [] }),
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  openOnTop: Schema('boolean', 'primitive-nullable', { defaultValue: null }),
  searchTerm: Schema('string', 'primitive', { defaultValue: '' }),
  pageNumber: Schema('integer', 'primitive', { defaultValue: 1 }),
  hideAddUnitButton: Schema('boolean', 'primitive', { defaultValue: false }),
  isAddUnitButtonExternalFunction: Schema('boolean', 'primitive', { defaultValue: false }),
  isUnitMultiSelectionAllowed: Schema('boolean', 'primitive', { defaultValue: true }),
  showResident: Schema('boolean', 'primitive', { defaultValue: false }),
}